import React, { memo, useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { LoginCallback } from '@okta/okta-react'
import links from '../enums/linksEnum'
import Dashboard from '../modules/dashboard/Dashboard'
import Contracts from '../modules/contracts/Contracts'
import Requests from '../modules/requests/Requests'
import Faq from '../modules/faq/Faq'
import News from '../modules/news/News'
import NewsDetails from '../modules/news/details/Details'
import RequestDetail from '../modules/requests/detail/RequestDetail'
import ProfilePage from '../modules/profile/ProfilePage'
import AlertDetails from '../modules/alert/Details'
import ServicesPage from '../modules/services/ServicesPage'
import ServiceDetails from '../modules/services/components/details/ServiceDetails'
import DetailFooterPage from '../modules/footer/DetailFooterPage'
import PaymentFinishedPage from '../modules/contracts/contracts_body/account/payment/PaymentFinishedPage'
import { useHistory } from 'react-router-dom'
import { updateGTM } from '../utils/gtm/updateGTM'
import FormulaireChangementAppartement from '../modules/changementAppartement/components/FormulaireChangementAppartement'

const Root = () => {
	const history = useHistory()

	useEffect(
		() => {
			updateGTM(history.location as unknown as Location)

			history.listen((location) => {
				updateGTM(location as unknown as Location)
			})
		}, [history]
	)

	return (
		<Switch>
			<Route path={links.dashboard} component={Dashboard} />
			<Route path={links.news} component={News} />
			<Route path={`${links.newsDetails}/:type/:id`} component={NewsDetails} />
			<Route path={links.contracts} component={Contracts} />
			<Route exact path={links.requests} component={Requests} />
			<Route exact path={`${links.requests}/:id`} component={RequestDetail} />
			<Route path={links.questions} component={Faq} />
			<Route path={links.checkOkta} component={LoginCallback} />
			<Route path={links.profile} component={ProfilePage} />
			<Route path={`${links.alertDetails}/:id`} component={AlertDetails} />
			<Route exact path={links.services} component={ServicesPage} />
			<Route exact path={`${links.services}/:id`} component={ServiceDetails} />
			<Route path={`${links.footer}/:id`} component={DetailFooterPage} />
			<Route path={`${links.payment}`} component={PaymentFinishedPage} />
			<Route path={`${links.formulaireChangementAppartement}`} component={FormulaireChangementAppartement} />
			<Route path="/" exact>
				<Redirect to={links.dashboard} />
			</Route>
		</Switch>
	)
}

export default memo(Root)
